import axios from 'api/axios'
import { Template } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * remark of template
 */
interface rejectTemplateBody {
	remarks: string
}

/**
 * API call for reject status of template
 * @param id - id of template to be send to backend for reject status of template
 * @returns AdminResponse - Response object returned from the server
 */

export const rejectTemplateStatus = async (
	id: string,
	body: rejectTemplateBody
) => {
	try {
		const { data } = await axios.patch<Template>(
			`templates/list/${id}/reject`,
			body
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default rejectTemplateStatus
